import { Filter } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Checkbox } from "../ui/checkbox";

export function ShoppingFilters({
  categoryFilter,
  setCategoryFilter,
  showChecked,
  setShowChecked,
  categories,
}) {
  return (
    <div className="flex flex-wrap gap-3 items-center">
      <Select value={categoryFilter} onValueChange={setCategoryFilter}>
        <SelectTrigger
          className="w-[160px] bg-slate-900 border-slate-800"
          data-testid="filter-category"
        >
          <Filter size={16} className="mr-2" />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Categories</SelectItem>
          {categories.map((cat) => (
            <SelectItem key={cat.id} value={cat.name}>
              {cat.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <label className="flex items-center gap-2 text-slate-400 cursor-pointer">
        <Checkbox
          checked={showChecked}
          onCheckedChange={setShowChecked}
          data-testid="show-checked-toggle"
        />
        <span className="text-sm">Show checked items</span>
      </label>
    </div>
  );
}
